var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0827 17.6248L22.9489 12.4998L14.0827 7.37484V17.6248ZM33.831 4.24859C34.0531 5.0515 34.2068 6.12775 34.3093 7.49442C34.4289 8.86109 34.4802 10.0398 34.4802 11.0648L34.5827 12.4998C34.5827 16.2411 34.3093 18.9915 33.831 20.7511C33.4039 22.2886 32.4131 23.2794 30.8756 23.7065C30.0727 23.9286 28.6035 24.0823 26.3485 24.1848C24.1277 24.3044 22.0948 24.3557 20.2156 24.3557L17.4993 24.4582C10.3414 24.4582 5.88268 24.1848 4.1231 23.7065C2.5856 23.2794 1.59477 22.2886 1.16768 20.7511C0.945599 19.9482 0.791849 18.8719 0.689349 17.5053C0.569766 16.1386 0.518516 14.9598 0.518516 13.9348L0.416016 12.4998C0.416016 8.75859 0.689349 6.00817 1.16768 4.24859C1.59477 2.71109 2.5856 1.72025 4.1231 1.29317C4.92602 1.07109 6.39518 0.917337 8.65018 0.814837C10.871 0.695254 12.9039 0.644004 14.7831 0.644004L17.4993 0.541504C24.6573 0.541504 29.116 0.814837 30.8756 1.29317C32.4131 1.72025 33.4039 2.71109 33.831 4.24859Z",
    fill: "#FF1616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e674b24abdd57697a11c21187b0a22d4.svg";
export { ForwardRef as ReactComponent };